<template>
  <!-- Main Content -->
  <div id="content">
    <!-- Begin Page Content -->
    <div class="container-fluid">
      <!-- Page Heading -->
      <h1 class="h3 mb-2 text-gray-800">Crear Subcategoría</h1>
      <!-- DataTales Example -->
      <div class="card shadow mb-4">
        <div class="card-body">
          <b-form @submit="onSubmit" @reset="onReset" v-if="show">
            <div class="row">
              <div class="col-6">
                <b-form-group label="Título" label-for="keyInput" >
                  <b-form-input id="keyInput"  v-model="form.description" required ></b-form-input>
                </b-form-group>
              </div>

            <div class="col-6">
              <b-form-group id="input-group-3" label="Categoría asociada:" label-for="input-category">
                <b-form-select
                  id="input-category"
                  v-model="form.categoryId"
                  :options="categories"
                  required

                ></b-form-select>
              </b-form-group>
            </div>
            </div>
            <b-button type="submit" variant="primary">Guardar</b-button>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import router from "../../../../router";

export default {
  data() {
    return {
      form: {
        description: '',
        categoryId: '',
      },
      categories: [],
      show: true,
      isEdit: false,
      subcategoryId: ''
    }
  },
  methods: {
    populateSelectCategories() {
      this.categories = this.modules.find(obj => obj.id === this.form.category).categories
    },
    loadCategory() {
      let loader = this.$loading.show({});
      axios.get(
        import.meta.env.VITE_API_BASE_URL + "/api/categories/list",
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
      .then((response) => {
        let arr = response.data;
        this.categories.push({text: 'Selecciona una categoría.', value: null})
        for (let item of arr) {
          this.categories.push({text: item.description, value: item.id})
        }
        loader.hide();
      })
      .catch((err) => {
        loader.hide();
        console.log(err.message);
      });
    },
    onSubmit(event) {
      let loader = this.$loading.show({});
      event.preventDefault()
      this.$toastr.defaultTimeout = 4000;
      this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
      if (this.isEdit) {
        axios.put(import.meta.env.VITE_API_BASE_URL + "/api/subcategory/edit/" + this.subcategoryId , this.form, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          }}).then(() => {
          this.$toastr.s(
            "Subcategoría Editada."
          );
          loader.hide();
          router.push({ path: `/admin-panel/subcategories` })
        }).catch((err) => {
          loader.hide();
          console.log(err.message);
          this.$toasted.error("Error al editar la subcategoría, posiblemente ya exista alguna con los mismos datos y estado.", {position: 'top-right', duration: 5000});
        });
      } else {
        axios.post(import.meta.env.VITE_API_BASE_URL + "/api/subcategory/save", this.form, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          }}).then(() => {
          this.$toastr.s(
            "Subcategoría Creada."
          );
          router.push({ path: `/admin-panel/subcategories` });
          loader.hide();
        }).catch((err) => {
          loader.hide();
          console.log(err.message);
          this.$toasted.error("Error al crear la subcategoría, posiblemente ya exista alguna con los mismos datos y estado.", {position: 'top-right', duration: 5000});
        });;

      }
    },
    onReset(event) {
      event.preventDefault()
    }
  },
  watch: {
    form: function () {
      if ('MathJax' in window) {
        this.$nextTick(function() {
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub]);
        });
      }
    },
    'form.category'() {
      this.populateSelectCategories();
    }
  },
  mounted() {
    this.loadCategory();
    if (this.$route.params.id) {
      this.subcategoryId =this.$route.params.id;
      this.isEdit = true;
      axios.get(
        import.meta.env.VITE_API_BASE_URL + "/api/subcategory/getById/" + this.subcategoryId,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
      .then((response) => {
        this.form.description = response.data.description
        this.form.categoryId = response.data.category.id
      }).catch((err) => {
        console.log(err.message);
      });
    }
  },
  beforeMount() {
    (function () {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src =
        "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.2/MathJax.js?config=TeX-AMS_HTML";
      document.getElementsByTagName("head")[0].appendChild(script);
    })();
  },
}
</script>
